import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { ProgressBar } from 'react-bootstrap';
import { AppModal, AppNotificationAlert } from '@/layout/AppComponents';
import PreventNavigation from './PreventNavigation';
import { axiosPath } from '../../../routing/helpers/router';
import useIsMounted from '../hooks/useIsMounted';

export default function LoopModal({
  route,
  value,
  title = '',
  size = 'md',
  confirmBtnText = 'Finalizar',
  onInit = () => {},
  onFinish = () => {},
  onConfirmFinish = () => {},
  onError = () => {},
  closeOnFinish = false,
  comment = null,
  contentClassName = null,
  getModalInfo,
}) {
  const isMounted = useIsMounted();
  const [loopInfo, setLoopInfo] = useState();
  const global = useSelector((state) => state.global);

  const handleLoop = useCallback(async () => {
    await axios
      .post(axiosPath(route), {
        tempBatchLoopID: loopInfo?.tempBatchLoopID,
        locale: global.urlData.lang,
        comment: comment || null,
        ...value,
      })
      .then(({ data }) => {
        if (isMounted.current) {
          setLoopInfo(data);
          if (getModalInfo) getModalInfo(loopInfo?.modalInfo);
        }
      })
      .catch(() => {
        onError();
        AppNotificationAlert({
          title: 'Error',
          message: 'Se ha producido un error',
          type: 'danger',
          duration: 5000,
        });
        // >> el dispatch falla
        // dispatch(errorHandler(e));
      });
  }, [loopInfo, value]);

  useEffect(() => {
    if (value) {
      onInit();
      handleLoop();
    }
  }, []);

  useEffect(() => {
    if (loopInfo && !loopInfo?.isFinished) {
      handleLoop();
    } else if (loopInfo && loopInfo.isFinished) {
      onFinish(loopInfo?.results);
      if (closeOnFinish) {
        setLoopInfo(undefined);
      }
    }
  }, [loopInfo]);

  return (
    <AppModal
      show={!getModalInfo}
      title={title}
      size={size}
      isCloseButton={false}
      isConfirmBtn={loopInfo?.isFinished}
      confirmBtnText={confirmBtnText}
      contentClassName={contentClassName}
      onConfirm={() => {
        if (loopInfo?.isFinished) {
          setLoopInfo(undefined);
          onConfirmFinish();
        }
      }}
    >
      {!loopInfo?.isFinished && <PreventNavigation />}
      <h4>{loopInfo?.modalInfo?.message || '-'}</h4>
      <ProgressBar
        animated
        now={loopInfo?.modalInfo?.percent || 0}
        label={`${parseInt(loopInfo?.modalInfo?.percent, 10)}%`}
      />
    </AppModal>
  );
}
